// @ts-nocheck
import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'lbca-popup-feedback',
    templateUrl: './popup-feedback.component.html',
    styleUrl: './popup-feedback.component.scss',
    imports: [NgTemplateOutlet]
})
export class PopupFeedbackComponent {
	public template!: TemplateRef<Object>;

	public containerDistance: any = {
		prop: '',
		value: '',
	};

	@Input()
	set templateRef(templateRef: TemplateRef<Object>) {
		this.template = templateRef;
		this.getMenuSize();
	}

	private getMenuSize(): void {
		const taskForm: HTMLObjectElement = document.querySelector(
			'#task-form-ref',
		) as HTMLObjectElement;
		const sidenavSize: number =
			document.querySelector('#side-nav-bar')?.getBoundingClientRect().width || 0;

		const distance: number = 142 - 40 - sidenavSize;

		if (taskForm) {
			this.containerDistance.prop = 'margin-left';
			this.containerDistance.value = -distance + 'px';
		} else {
			this.containerDistance.prop = 'padding-left';
			this.containerDistance.value = sidenavSize + 'px';
		}
	}
}
